export enum AvailabilityState {
  Add,
  PreOrder,
  BackOrder,
  WhereToBuy,
  ComingSoon,
}

export interface WithPrice<T> {
  product: T;
  price?: StandardPriceModel;
}

export interface StandardPriceModel {
  productId?: number;
  familyId?: number;
  groupId?: number;
  sku?: string;

  discountedPrice?: number;
  discountedPriceWithoutVat?: number;
  listedPrice?: number;
  listedPriceWithoutVat?: number;

  availabilityState?: AvailabilityState;
  currency?: string;
  discountPercentage?: number;
  isDiscounted?: boolean;
  offerEndDate?: string;

  calloutMsg?: string;
  couponCalloutMessage?: string;
  lowestPriceInLastMonth?: number;
}

export enum ProductType {
  Family = 'f',
  Group = 'g',
  Product = 'p',
}
